import React from "react";
import { Routes, Route } from "react-router-dom";
import AddingCard from "./AddingCard";
import VerifyingWallet from "./VerifyingWallet";
import VerifyingCard from "./VerifyingCard";
import Success from "./Success";
import Failure from "./Failure";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/add-card" element={<AddingCard />} />
        <Route path="/add-card/:token" element={<AddingCard />} />
        <Route path="/add-card/:gateway/:token" element={<AddingCard />} />
        <Route path="/verify-card" element={<VerifyingCard />} />
        <Route path="/verify-card/:gateway" element={<VerifyingCard />} />
        <Route path="/verify-card/:gateway/:token" element={<VerifyingCard />} />
        <Route path="/verify-wallet" element={<VerifyingWallet />} />
        <Route path="/verify-wallet/:token" element={<VerifyingWallet />} />
        <Route path="/verify-wallet/:gateway/:token" element={<VerifyingWallet />} />
        <Route path="/success" element={<Success />} />
        <Route path="/failure" element={<Failure />} />
      </Routes>
    </div>
  );
}

export default App;
